/**
 * Lazy loading wrappers for ArcGIS modules to improve initial bundle size
 */

// Core map modules
// export const loadMap = () => import('@arcgis/core/Map')
// export const loadWebMap = () => import('@arcgis/core/WebMap')
// export const loadWebScene = () => import('@arcgis/core/WebScene')
// export const loadMapView = () => import('@arcgis/core/views/MapView')
// export const loadSceneView = () => import('@arcgis/core/views/SceneView')

// Layer modules
export const loadFeatureLayer = () => import('@arcgis/core/layers/FeatureLayer')
// export const loadTileLayer = () => import('@arcgis/core/layers/TileLayer')
export const loadGraphicsLayer = () => import('@arcgis/core/layers/GraphicsLayer')

// Geometry modules
export const loadPoint = () => import('@arcgis/core/geometry/Point')
export const loadPolygon = () => import('@arcgis/core/geometry/Polygon')
export const loadExtent = () => import('@arcgis/core/geometry/Extent')

// Symbol modules
export const loadSimpleMarkerSymbol = () => import('@arcgis/core/symbols/SimpleMarkerSymbol')
export const loadSimpleFillSymbol = () => import('@arcgis/core/symbols/SimpleFillSymbol')

// Graphics
export const loadGraphic = () => import('@arcgis/core/Graphic')

// Query
export const loadQuery = () => import('@arcgis/core/rest/support/Query')

// Popup
export const loadPopupTemplate = () => import('@arcgis/core/PopupTemplate')

// Renderer
export const loadSimpleRenderer = () => import('@arcgis/core/renderers/SimpleRenderer')

// Identity Manager
// export const loadIdentityManager = () => import('@arcgis/core/identity/IdentityManager')


// Load all essential modules for MapService
export async function loadEssentialModules() {
  const [
    // MapModule,
    // WebMapModule,
    // MapViewModule,
    FeatureLayerModule,
    GraphicsLayerModule,
    GraphicModule,
    PointModule,
    SimpleMarkerSymbolModule,
  ] = await Promise.all([
    // loadMap(),
    // loadWebMap(),
    // loadMapView(),
    loadFeatureLayer(),
    loadGraphicsLayer(),
    loadGraphic(),
    loadPoint(),
    loadSimpleMarkerSymbol(),
  ])

  return {
    // Map: MapModule.default,
    // WebMap: WebMapModule.default,
    // MapView: MapViewModule.default,
    FeatureLayer: FeatureLayerModule.default,
    GraphicsLayer: GraphicsLayerModule.default,
    Graphic: GraphicModule.default,
    Point: PointModule.default,
    SimpleMarkerSymbol: SimpleMarkerSymbolModule.default,
  }
}
